/* Social Media — the fields and the one rule that shapes them.
 *
 * TRANSCRIBED from About/Social.jsx.
 */

/* Transcribed verbatim from Social.jsx's addHttpsToFilled. */
export const addHttpsToFilled = (url) => {
  if (!url || url.trim() === "") return null;
  if (!/^https?:\/\//i.test(url.trim())) return `https://${url.trim()}`;
  return url.trim();
};

/* The five fields, in the design's order — which is also the live form's:
   X and Facebook, then LinkedIn and Instagram, then Website across the row. */
export const SOCIAL_FIELDS = [
  { key: "twitter", label: "X (previously Twitter)", placeholder: "https://x.com/" },
  { key: "facebook", label: "Facebook", placeholder: "https://facebook.com" },
  { key: "linkedin", label: "LinkedIn", placeholder: "https://linkedin.com/" },
  { key: "instagram", label: "Instagram", placeholder: "https://instagram.com" },
  { key: "website", label: "Website", placeholder: "https://www.example.com" },
];

export const SOCIAL_KEYS = SOCIAL_FIELDS.map((f) => f.key);

/* Transcribed: each field is read from the draft first, then the company
   record, then blank — and every value passes through addHttpsToFilled. */
export const socialValues = (source = {}, fallback = {}) =>
  SOCIAL_KEYS.reduce((acc, key) => {
    acc[key] = addHttpsToFilled(source?.[key]) || addHttpsToFilled(fallback?.[key]) || "";
    return acc;
  }, {});

/* Transcribed: the five fields are submitted as strings, so an empty box is
   sent as "" rather than omitted or nulled. The live code does this by
   template interpolation; stated plainly here. */
export const socialPayload = (values = {}, status) => ({
  twitter: `${values.twitter ?? ""}`,
  facebook: `${values.facebook ?? ""}`,
  instagram: `${values.instagram ?? ""}`,
  linkedin: `${values.linkedin ?? ""}`,
  website: `${values.website ?? ""}`,
  social_media_status: status,
});

/* Transcribed: the glyph reads the DRAFT's social_media_status when a draft is
   awaiting review, and the company's otherwise. */
export const socialDisplayStatus = (company, draft) => {
  if (draft?.social_media_status === "raised" || draft?.social_media_status === "Modified") {
    return "Requested";
  }
  return company?.social_media_status;
};
